<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      minWidth:'',
    };
  },
  methods: {
    getWidth(){
      // this.height = window.innerWidth - 70 + 'px';
      this.minWidth = String(window.innerWidth)
    },
  },
  created() {

  },
  mounted() {
    window.addEventListener('resize', this.getWidth);
    this.getWidth()
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
/*滚动条 start*/
::-webkit-scrollbar {
width: 8px;
height: 8px;
background-color: #f8f8f8;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
background: #0C1364 ;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
background-color:#1725b9;
border-radius: 20px;
}
::-webkit-scrollbar-thumb:hover {
-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
background-color:#1725b9;
}
/*滚动条 end*/
html,
body {
	width: 100%;
	height: 100%;
  background: #0C1364;
  // overflow-x:auto;
}
</style>
